export default function TechStack() {
  const tools = [
    { role: 'データ中枢', tool: 'Google Sheets', icon: 'ri-file-excel-line', color: 'bg-green-500' },
    { role: '計算脳', tool: 'GAS', icon: 'ri-code-s-slash-line', color: 'bg-blue-500' },
    { role: 'API', tool: 'Amazon SP-API', icon: 'ri-plug-line', color: 'bg-orange-500' },
    { role: '相場', tool: 'Keepa', icon: 'ri-line-chart-line', color: 'bg-purple-500' },
    { role: '抽出', tool: 'Octoparse', icon: 'ri-database-line', color: 'bg-teal-500' },
    { role: 'AI', tool: 'ChatGPT', icon: 'ri-robot-line', color: 'bg-pink-500' },
    { role: '可視化', tool: 'Looker Studio', icon: 'ri-dashboard-line', color: 'bg-indigo-500' }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-gray-900 mb-6">
            Amazon自動化の<strong className="text-primary">技術構成</strong>（実戦）
          </h2>
        </div>
        
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b-2 border-gray-200">
                  <th className="px-6 py-4 text-left font-bold text-lg text-gray-900">役割</th>
                  <th className="px-6 py-4 text-left font-bold text-lg text-gray-900">ツール</th>
                </tr>
              </thead>
              <tbody>
                {tools.map((item, index) => (
                  <tr key={index} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-5">
                      <span className="font-bold text-gray-900">{item.role}</span>
                    </td>
                    <td className="px-6 py-5">
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 ${item.color} rounded-lg flex items-center justify-center`}>
                          <i className={`${item.icon} text-xl text-white`}></i>
                        </div>
                        <span className="text-gray-700 font-medium">{item.tool}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
